import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ContactRound, Save, X } from 'lucide-react'
import { tr } from 'i18n'
import s from '../Management.module.scss'
import './DriverInnDialog.scss'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'

type Props = { name: string; currentInn: string; busy: boolean; error: string; onClose: () => void; onConfirm: (inn: string, pin: string) => void }

export default function DriverInnDialog({ name, currentInn, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const [inn, setInn] = useState(currentInn)
  const [pin, setPin] = useState('')
  const valid = /^[0-9]{14}$/.test(inn) && /^[0-9]{4}$/.test(pin)
  return <div className={s.overlay}>
    <form className={`${s.dialog} driver-inn-dialog`} role="dialog" aria-modal="true" aria-labelledby="driver-inn-title"
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(inn, pin) }}>
      <h2 id="driver-inn-title"><ContactRound size={20} aria-hidden="true" />{tr('Смена ИНН водителя')}</h2>
      <p>{name}</p>
      <div className="driver-inn-dialog__current"><span>{tr('Текущий ИНН')}</span><strong>{currentInn || '—'}</strong></div>
      <p className={s.muted}>{tr('После изменения водитель входит по новому ИНН. PIN и пароль сохраняются.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <label className={s.field}>{tr('Новый ИНН')}<input required autoFocus inputMode="numeric" pattern="[0-9]{14}" maxLength={14}
        disabled={busy} value={inn} onChange={event => setInn(event.target.value.replace(/\D/g, '').slice(0, 14))} /></label>
      <p className={s.muted}>{tr('ИНН должен состоять из 14 цифр.')}</p>
      <ActorPinField value={pin} onChange={setPin} disabled={busy} />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.primary} disabled={busy || !valid}><Save size={14} aria-hidden="true" />{tr('Сохранить ИНН')}</button>
      </div>
    </form>
  </div>
}
